import Vue from "vue";
import Router from "vue-router";
import Login from "./components/land/Login.vue";
import Login2 from "./components/land/Login2.vue";
import Dashboard from "./components/land/Dashboard.vue";
import Home from "./components/land/Home.vue";
import Users from "./components/Control/Users.vue";
import Banks from "./components/Control/Banks.vue";
import Cars from "./components/Control/Cars.vue";
import Clients from "./components/Control/Clients.vue";
import ClientClasses from "./components/Control/ClientClasses.vue";
import Employee from "./components/Control/Employee.vue";
import Groups from "./components/Control/Groups.vue";
import Importers from "./components/Control/Importers.vue";
import Items from "./components/Control/Items.vue";
import ItemPriceLayer from "./components/Control/ItemPriceLayer.vue";
import Jobs from "./components/Control/Jobs.vue";
import OfferItems from "./components/Control/OfferItems.vue";
import Regions from "./components/Control/Regions.vue";
import Money from "./components/Control/Money.vue";
import SadadStatus from "./components/Control/SadadStatus.vue";
import Khazina from "./components/Control/Khazina.vue";
import SadadTypes from "./components/Control/SadadTypes.vue";
import Stores from "./components/Control/Stores.vue";
import Employers from "./components/Control/Employers.vue";
import Branches from "./components/Control/Branches.vue";
import ClientUsers from "./components/Control/ClientUsers.vue";
import BuyFatwora from "./components/FatworaOperations/BuyFatwora.vue";
import BuyFatworaPrint from "./components/FatworaOperations/BuyFatworaPrint.vue";
import BuyFatworaReback from "./components/FatworaOperations/BuyFatworaReback.vue";
import BuyFatworaConfirmation from "./components/FatworaOperations/BuyFatworaConfirmation.vue";
import SellFatwora from "./components/FatworaOperations/SellFatwora.vue";
import SellFatworaReback from "./components/FatworaOperations/SellFatworaReback.vue";
import PublicRebackFatwora from "./components/FatworaOperations/PublicRebackFatwora.vue";
import TanfizFatworas from "./components/FatworaOperations/TanfizFatworas.vue";
import SarfFromStore from "./components/FatworaOperations/SarfFromStore.vue";
import TaslimFatworas from "./components/FatworaOperations/TaslimFatworas.vue";
import SolmtFatworas from "./components/FatworaOperations/SolmtFatworas.vue";
import FatworaDetailByID from "./components/FatworaOperations/FatworaDetailByID.vue";
import FatworaDetailByIDStore from "./components/FatworaOperations/FatworaDetailByIDStore.vue";
import FatworaRebackDetailByID from "./components/FatworaOperations/FatworaRebackDetailByID.vue";
import Rebackfatworas from "./components/FatworaOperations/Rebackfatworas.vue";
import FinalFatworas from "./components/FatworaOperations/FinalFatworas.vue";
import FinalFatworasPrint from "./components/FatworaOperations/FinalFatworasPrint.vue";
import OrderConfirmation from "./components/FatworaOperations/OrderConfirmation.vue";
import StoreTransfer from "./components/StoreOperation/StoreTransfer.vue";
import StoreTransferFrom from "./components/StoreOperation/StoreTransferFrom.vue";
import StoreTransferTo from "./components/StoreOperation/StoreTransferTo.vue";
import StoreTransferFatworas from "./components/StoreOperation/StoreTransferFatworas.vue";
import SanfCard from "./components/StoreOperation/SanfCard.vue";
import StoreGard from "./components/StoreOperation/StoreGard.vue";
import EmployerStore from "./components/StoreOperation/EmployerStore.vue";
import StoreItemStart from "./components/StoreOperation/StoreItemStart.vue";
import MakhzonCost from "./components/StoreOperation/MakhzonCost.vue";
import ClientSadad from "./components/khazina/ClientSadad.vue";
import ImporterSadad from "./components/khazina/ImporterSadad.vue";
import ClientKhasm from "./components/khazina/ClientKhasm.vue";
import Deposit from "./components/khazina/Deposit.vue";
import Withdrew from "./components/khazina/Withdrew.vue";
import KhaznaTransfer from "./components/khazina/KhaznaTransfer.vue";
import Masrofat from "./components/khazina/Masrofat.vue";
import Ohda from "./components/khazina/Ohda.vue";
import BankCheque from "./components/Bank/BankCheque.vue";
import BankDeposite from "./components/Bank/BankDeposite.vue";
import BankTransfer from "./components/Bank/BankTransfer.vue";
import BankWithdrew from "./components/Bank/BankWithdrew.vue";
import EmployersOmola from "./components/HR/EmployersOmola.vue";
import EmployerBadalat from "./components/HR/EmployerBadalat.vue";
import EmployerHafez from "./components/HR/EmployerHafez.vue";
import EmployerKhasm from "./components/HR/EmployerKhasm.vue";
import EmployerSolfa from "./components/HR/EmployerSolfa.vue";
import SalaryInput from "./components/HR/SalaryInput.vue";
import Vacancy from "./components/HR/Vacancy.vue";
import EmployerSalary from "./components/HR/EmployerSalary.vue";
import Events from "./components/HR/Events.vue";
import Attends from "./components/HR/Attends.vue";
import Tracking from "./components/HR/Tracking.vue";
import Chat from "./components/HR/Chat.vue";
import MandobTargetInput from "./components/HR/MandobTargetInput.vue";
import Profit from "./components/HR/Profit.vue";
import ProfiItem from "./components/HR/ProfiItem.vue";
import AttendReport from "./components/HR/AttendReport.vue";
import PrintClientAccount from "./components/client/PrintClientAccount";
import PrintClientAccountDetail from "./components/client/PrintClientAccountDetail";
import ClientDetailAccount from "./components/client/ClientDetailAccount";
import ClientAccount from "./components/client/ClientAccount";
import ImporterAccount from "./components/client/ImporterAccount";
import MandobClientTypeReport from "./components/Reports/MandobClientTypeReport.vue";
import MandobItemReport from "./components/Reports/MandobItemReport.vue";
import MandobTarget from "./components/Reports/MandobTarget.vue";
import MandobSalesReport from "./components/Reports/MandobSalesReport.vue";
import TahsilatReport from "./components/Reports/TahsilatReport.vue";
import TasksReport from "./components/clientReport/TasksReport.vue";
import ClientsWithBranch from "./components/clientReport/ClientsWithBranch.vue";
import ClientsWithMandob from "./components/clientReport/ClientsWithMandob.vue";
import ClientsWithNew from "./components/clientReport/ClientsWithNew.vue";
import ClientsWithRegion from "./components/clientReport/ClientsWithRegion.vue";
import BranchSalesReport from "./components/Reports/BranchSalesReport.vue";
import BranchSalesReportShort from "./components/Reports/BranchSalesReportShort.vue";
import BranchSalesReportAllDetails from "./components/Reports/BranchSalesReportAllDetails.vue";
import BranchMadioniaReport from "./components/Reports/BranchMadioniaReport.vue";
import CompanyMadioniaReport from "./components/Reports/CompanyMadioniaReport.vue";
import CompanySalesReport from "./components/Reports/CompanySalesReport.vue";
import ItemSalesReport from "./components/Reports/ItemSalesReport.vue";
import ItemBuyReport from "./components/Reports/ItemBuyReport.vue";
import ItemClientTypeReport from "./components/Reports/ItemClientTypeReport.vue";
import MandobClientMadioniaReport from "./components/Reports/MandobClientMadioniaReport.vue";
import MandobClientSadadReport from "./components/Reports/MandobClientSadadReport.vue";
import StoreItemTransferReport from "./components/Reports/StoreItemTransferReport.vue";
import StoreOneItemTransferReport from "./components/Reports/StoreOneItemTransferReport.vue";
import StoreGardDetailReport from "./components/Reports/StoreGardDetailReport.vue";
import KhazinaClientSadadReport from "./components/Reports/KhazinaClientSadadReport.vue";
import KhazinaInputReport from "./components/Reports/KhazinaInputReport.vue";
import KhazinaInputDetailReport from "./components/Reports/KhazinaInputDetailReport.vue";
import KhazinaImporterSadadReport from "./components/Reports/KhazinaImporterSadadReport.vue";
import EmployerSalaryReport from "./components/Reports/EmployerSalaryReport.vue";
import EmployerOmolaReport from "./components/Reports/EmployerOmolaReport.vue";
import RebackClientReport from "./components/Reports/RebackClientReport.vue";
import RebackMandobReport from "./components/Reports/RebackMandobReport.vue";
import RebackItemReport from "./components/Reports/RebackItemReport.vue";
import RebackItemBuyReport from "./components/Reports/RebackItemBuyReport.vue";
import RebackImporterReport from "./components/Reports/RebackImporterReport.vue";
import MasrofAllReport from "./components/Reports/MasrofAllReport.vue";
import MasrofWithTypeReport from "./components/Reports/MasrofWithTypeReport.vue";
import RebackSellAll from "./components/Reports/RebackSellAll.vue";
import RebackSellAllByFatwora from "./components/Reports/RebackSellAllByFatwora.vue";
import RebackBuyAll from "./components/Reports/RebackBuyAll.vue";
import UserBehaviorReport from "./components/Reports/UserBehaviorReport.vue";
import StoreMovementReport from "./components/Reports/StoreMovementReport.vue";
import StoreMovementAllReport from "./components/Reports/StoreMovementAllReport.vue";
import ItemSalesAverageReport from "./components/Reports/ItemSalesAverageReport.vue";
import ClientSalesValueReport from "./components/Reports/ClientSalesValueReport.vue";
import ClientSadadSalesAverageReport from "./components/Reports/ClientSadadSalesAverageReport.vue";
import DashboardDetails from "./components/PageDetails/DashboardDetails.vue";
import StoreOperationDetails from "./components/PageDetails/StoreOperationDetails.vue";
import AccountDetails from "./components/PageDetails/AccountDetails.vue";
import BankDetails from "./components/PageDetails/BankDetails.vue";
import BuyDetails from "./components/PageDetails/BuyDetails.vue";
import EmployerReportDetails from "./components/PageDetails/EmployerReportDetails.vue";
import HrDetails from "./components/PageDetails/HrDetails.vue";
import ImporterReportDetails from "./components/PageDetails/ImporterReportDetails.vue";
import KhazinaDetails from "./components/PageDetails/KhazinaDetails.vue";
import KhazinaReportDetails from "./components/PageDetails/KhazinaReportDetails.vue";
import ManageReportDetails from "./components/PageDetails/ManageReportDetails.vue";
import RebackReportDetails from "./components/PageDetails/RebackReportDetails.vue";
import SalesDetails from "./components/PageDetails/SalesDetails.vue";
import SalesReportDetails from "./components/PageDetails/SalesReportDetails.vue";
import StorereportDetails from "./components/PageDetails/StorereportDetails.vue";
import TaxFatwora from "./components/print/TaxFatwora.vue";
import FatworaBarcode from "./components/fatwora_barcode/FatworaBarcode.vue";

import AddNewClient from "./components/mobile/AddNewClient.vue";
import mandobVisits from "./components/mobile/Visits.vue";
import Tasks from "./components/mobile/Tasks.vue";
import Tahsilat from "./components/mobile/Tahsilat.vue";
import Track from "./components/mobile/Track.vue";
import Barcode from "./components/barcode/Barcode.vue";

import ItemSalesReportPrint from "./components/reports_print/sales/ItemSalesReportPrint";
import ItemClientTypeReportPrint from "./components/reports_print/sales/ItemClientTypeReportPrint";
import MandobSalesReportPrint from "./components/reports_print/sales/MandobSalesReportPrint";
import MandobClientTypeReportPrint from "./components/reports_print/sales/MandobClientTypeReportPrint";
import MandobItemReportPrint from "./components/reports_print/sales/MandobItemReportPrint";
import MandobClientSadadReportPrint from "./components/reports_print/sales/MandobClientSadadReportPrint";
import MandobClientMadioniaReportPrint from "./components/reports_print/sales/MandobClientMadioniaReportPrint";
import ItemSalesAverageReportPrint from "./components/reports_print/sales/ItemSalesAverageReportPrint";
import ClientSalesValueReportPrint from "./components/reports_print/sales/ClientSalesValueReportPrint";
import ClientSadadSalesAverageReportPrint from "./components/reports_print/sales/ClientSadadSalesAverageReportPrint";
import StoreItemTransferReportPrint from "./components/reports_print/store/StoreItemTransferReportPrint";
import StoreOneItemTransferReportPrint from "./components/reports_print/store/StoreOneItemTransferReportPrint";
import StoreMovementReportPrint from "./components/reports_print/store/StoreMovementReportPrint";
import StoreMovementAllReportPrint from "./components/reports_print/store/StoreMovementAllReportPrint";
import KhazinaClientSadadReportPrint from "./components/reports_print/khazina/KhazinaClientSadadReportPrint";
import KhazinaInputDetailReportPrint from "./components/reports_print/khazina/KhazinaInputDetailReportPrint";
import MasrofAllReportPrint from "./components/reports_print/khazina/MasrofAllReportPrint";
import MasrofWithTypeReportPrint from "./components/reports_print/khazina/MasrofWithTypeReportPrint";
import BranchSalesReportPrint from "./components/reports_print/management/BranchSalesReportPrint";
import BranchSalesReportAllDetailsPrint from "./components/reports_print/management/BranchSalesReportAllDetailsPrint";
import CompanySalesReportPrint from "./components/reports_print/management/CompanySalesReportPrint";
import BranchMadioniaReportPrint from "./components/reports_print/management/BranchMadioniaReportPrint";
import CompanyMadioniaReportPrint from "./components/reports_print/management/CompanyMadioniaReportPrint";
import BarcodeSerial from "./components/print/BarcodeSerial";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        userAuth: true
      },
      children: [
        {
          path: "/",
          name: "Home",
          component: Home
        },
        {
          path: "/Barcode",
          name: "Barcode",
          component: Barcode
        },
        {
          path: "/Users",
          name: "Users",
          component: Users
        },
        {
          path: "/Banks",
          name: "Banks",
          component: Banks
        },
        {
          path: "/Money",
          name: "Money",
          component: Money
        },
        {
          path: "/Masrofat",
          name: "Masrofat",
          component: Masrofat
        },
        {
          path: "/Cars",
          name: "Cars",
          component: Cars
        },
        {
          path: "/Clients",
          name: "Clients",
          component: Clients
        },
        {
          path: "/ClientClasses",
          name: "ClientClasses",
          component: ClientClasses
        },
        {
          path: "/Employee",
          name: "Employee",
          component: Employee
        },
        {
          path: "/Groups",
          name: "Groups",
          component: Groups
        },
        {
          path: "/EmployerBadalat",
          name: "EmployerBadalat",
          component: EmployerBadalat
        },
        {
          path: "/EmployerHafez",
          name: "EmployerHafez",
          component: EmployerHafez
        },
        {
          path: "/EmployerKhasm",
          name: "EmployerKhasm",
          component: EmployerKhasm
        },
        {
          path: "/EmployerSolfa",
          name: "EmployerSolfa",
          component: EmployerSolfa
        },
        {
          path: "/Importers",
          name: "Importers",
          component: Importers
        },
        {
          path: "/Items",
          name: "Items",
          component: Items
        },
        {
          path: "/ItemPriceLayer",
          name: "ItemPriceLayer",
          component: ItemPriceLayer
        },
        {
          path: "/Jobs",
          name: "Jobs",
          component: Jobs
        },
        {
          path: "/OfferItems",
          name: "OfferItems",
          component: OfferItems
        },
        {
          path: "/Regions",
          name: "Regions",
          component: Regions
        },
        {
          path: "/SadadStatus",
          name: "SadadStatus",
          component: SadadStatus
        },
        {
          path: "/Khazina",
          name: "Khazina",
          component: Khazina
        },
        {
          path: "/Stores",
          name: "Stores",
          component: Stores
        },
        {
          path: "/Employers",
          name: "Employers",
          component: Employers
        },
        {
          path: "/Branches",
          name: "Branches",
          component: Branches
        },
        {
          path: "/ClientUsers",
          name: "ClientUsers",
          component: ClientUsers
        },
        {
          path: "/SadadTypes",
          name: "SadadTypes",
          component: SadadTypes
        },
        {
          path: "/BuyFatwora",
          name: "BuyFatwora",
          component: BuyFatwora
        },
        {
          path: "/BuyFatworaPrint/:id",
          name: "BuyFatworaPrint",
          component: BuyFatworaPrint
        },
        {
          path: "/BuyFatworaReback",
          name: "BuyFatworaReback",
          component: BuyFatworaReback
        },
        {
          path: "/BuyFatworaConfirmation",
          name: "BuyFatworaConfirmation",
          component: BuyFatworaConfirmation
        },
        {
          path: "/SellFatwora",
          name: "SellFatwora",
          component: SellFatwora
        },
        {
          path: "/SellFatworaReback",
          name: "SellFatworaReback",
          component: SellFatworaReback
        },
        {
          path: "/PublicRebackFatwora",
          name: "PublicRebackFatwora",
          component: PublicRebackFatwora
        },
        {
          path: "/TanfizFatworas",
          name: "TanfizFatworas",
          component: TanfizFatworas
        },
        {
          path: "/SarfFromStore",
          name: "SarfFromStore",
          component: SarfFromStore
        },
        {
          path: "/TaslimFatworas",
          name: "TaslimFatworas",
          component: TaslimFatworas
        },
        {
          path: "/SolmtFatworas",
          name: "SolmtFatworas",
          component: SolmtFatworas
        },
        {
          path: "/Rebackfatworas",
          name: "Rebackfatworas",
          component: Rebackfatworas
        },
        {
          path: "/FatworaDetailByID/:fatwora_id",
          name: "FatworaDetailByID",
          component: FatworaDetailByID
        },
        {
          path: "/FatworaDetailByIDStore/:fatwora_id",
          name: "FatworaDetailByIDStore",
          component: FatworaDetailByIDStore
        },
        {
          path: "/FatworaRebackDetailByID/:fatwora_id",
          name: "FatworaRebackDetailByID",
          component: FatworaRebackDetailByID
        },
        {
          path: "/StoreTransfer",
          name: "StoreTransfer",
          component: StoreTransfer
        },
        {
          path: "/StoreTransferFrom",
          name: "StoreTransferFrom",
          component: StoreTransferFrom
        },
        {
          path: "/StoreTransferTo",
          name: "StoreTransferTo",
          component: StoreTransferTo
        },
        {
          path: "/StoreTransferFatworas",
          name: "StoreTransferFatworas",
          component: StoreTransferFatworas
        },
        {
          path: "/ClientSadad",
          name: "ClientSadad",
          component: ClientSadad
        },
        {
          path: "/ImporterSadad",
          name: "ImporterSadad",
          component: ImporterSadad
        },
        {
          path: "/ClientKhasm",
          name: "ClientKhasm",
          component: ClientKhasm
        },
        {
          path: "/Deposit",
          name: "Deposit",
          component: Deposit
        },
        {
          path: "/Withdrew",
          name: "Withdrew",
          component: Withdrew
        },
        {
          path: "/KhaznaTransfer",
          name: "KhaznaTransfer",
          component: KhaznaTransfer
        },
        {
          path: "/Ohda",
          name: "Ohda",
          component: Ohda
        },
        {
          path: "/SanfCard",
          name: "SanfCard",
          component: SanfCard
        },
        {
          path: "/StoreGard",
          name: "StoreGard",
          component: StoreGard
        },
        {
          path: "/EmployerStore",
          name: "EmployerStore",
          component: EmployerStore
        },
        {
          path: "/StoreItemStart",
          name: "StoreItemStart",
          component: StoreItemStart
        },
        {
          path: "/MakhzonCost",
          name: "MakhzonCost",
          component: MakhzonCost
        },
        {
          path: "/BankCheque",
          name: "BankCheque",
          component: BankCheque
        },
        {
          path: "/BankDeposite",
          name: "BankDeposite",
          component: BankDeposite
        },
        {
          path: "/BankTransfer",
          name: "BankTransfer",
          component: BankTransfer
        },
        {
          path: "/BankWithdrew",
          name: "BankWithdrew",
          component: BankWithdrew
        },
        {
          path: "/EmployersOmola",
          name: "EmployersOmola",
          component: EmployersOmola
        },
        {
          path: "/EmployerSalary",
          name: "EmployerSalary",
          component: EmployerSalary
        },
        {
          path: "/Events",
          name: "Events",
          component: Events
        },
        {
          path: "/Attends",
          name: "Attends",
          component: Attends
        },
        {
          path: "/Tracking",
          name: "Tracking",
          component: Tracking
        },
        {
          path: "/SalaryInput",
          name: "SalaryInput",
          component: SalaryInput
        },
        {
          path: "/Vacancy",
          name: "Vacancy",
          component: Vacancy
        },
        {
          path: "/ClientDetailAccount",
          name: "ClientDetailAccount",
          component: ClientDetailAccount
        },
        {
          path: "/PrintClientAccount",
          name: "PrintClientAccount",
          component: PrintClientAccount
        },
        {
          path: "/PrintClientAccountDetail",
          name: "PrintClientAccountDetail",
          component: PrintClientAccountDetail
        },
        {
          path: "/ClientAccount",
          name: "ClientAccount",
          component: ClientAccount
        },
        {
          path: "/MandobClientTypeReport",
          name: "MandobClientTypeReport",
          component: MandobClientTypeReport
        },
        {
          path: "/MandobItemReport",
          name: "MandobItemReport",
          component: MandobItemReport
        },
        {
          path: "/MandobTarget",
          name: "MandobTarget",
          component: MandobTarget
        },
        {
          path: "/MandobSalesReport",
          name: "MandobSalesReport",
          component: MandobSalesReport
        },
        {
          path: "/TahsilatReport",
          name: "TahsilatReport",
          component: TahsilatReport
        },
        {
          path: "/AttendReport",
          name: "AttendReport",
          component: AttendReport
        },
        {
          path: "/TasksReport",
          name: "TasksReport",
          component: TasksReport
        },
        {
          path: "/ClientsWithBranch",
          name: "ClientsWithBranch",
          component: ClientsWithBranch
        },
        {
          path: "/ClientsWithMandob",
          name: "ClientsWithMandob",
          component: ClientsWithMandob
        },
        {
          path: "/ClientsWithNew",
          name: "ClientsWithNew",
          component: ClientsWithNew
        },
        {
          path: "/ClientsWithRegion",
          name: "ClientsWithRegion",
          component: ClientsWithRegion
        },
        {
          path: "/BranchSalesReport",
          name: "BranchSalesReport",
          component: BranchSalesReport
        },
        {
          path: "/BranchSalesReportShort",
          name: "BranchSalesReportShort",
          component: BranchSalesReportShort
        },
        {
          path: "/BranchSalesReportAllDetails",
          name: "BranchSalesReportAllDetails",
          component: BranchSalesReportAllDetails
        },
        {
          path: "/BranchMadioniaReport",
          name: "BranchMadioniaReport",
          component: BranchMadioniaReport
        },
        {
          path: "/CompanyMadioniaReport",
          name: "CompanyMadioniaReport",
          component: CompanyMadioniaReport
        },
        {
          path: "/CompanySalesReport",
          name: "CompanySalesReport",
          component: CompanySalesReport
        },
        {
          path: "/ItemSalesReport",
          name: "ItemSalesReport",
          component: ItemSalesReport
        },
        {
          path: "/ItemBuyReport",
          name: "ItemBuyReport",
          component: ItemBuyReport
        },
        {
          path: "/ItemClientTypeReport",
          name: "ItemClientTypeReport",
          component: ItemClientTypeReport
        },
        {
          path: "/MandobClientMadioniaReport",
          name: "MandobClientMadioniaReport",
          component: MandobClientMadioniaReport
        },
        {
          path: "/MandobClientSadadReport",
          name: "MandobClientSadadReport",
          component: MandobClientSadadReport
        },
        {
          path: "/StoreItemTransferReport",
          name: "StoreItemTransferReport",
          component: StoreItemTransferReport
        },
        {
          path: "/StoreOneItemTransferReport",
          name: "StoreOneItemTransferReport",
          component: StoreOneItemTransferReport
        },
        {
          path: "/StoreGardDetailReport",
          name: "StoreGardDetailReport",
          component: StoreGardDetailReport
        },
        {
          path: "/KhazinaClientSadadReport",
          name: "KhazinaClientSadadReport",
          component: KhazinaClientSadadReport
        },
        {
          path: "/KhazinaInputReport",
          name: "KhazinaInputReport",
          component: KhazinaInputReport
        },
        {
          path: "/KhazinaInputDetailReport",
          name: "KhazinaInputDetailReport",
          component: KhazinaInputDetailReport
        },
        {
          path: "/KhazinaImporterSadadReport",
          name: "KhazinaImporterSadadReport",
          component: KhazinaImporterSadadReport
        },
        {
          path: "/EmployerSalaryReport",
          name: "EmployerSalaryReport",
          component: EmployerSalaryReport
        },
        {
          path: "/EmployerOmolaReport",
          name: "EmployerOmolaReport",
          component: EmployerOmolaReport
        },
        {
          path: "/RebackClientReport",
          name: "RebackClientReport",
          component: RebackClientReport
        },
        {
          path: "/RebackMandobReport",
          name: "RebackMandobReport",
          component: RebackMandobReport
        },
        {
          path: "/RebackItemReport",
          name: "RebackItemReport",
          component: RebackItemReport
        },
        {
          path: "/RebackItemBuyReport",
          name: "RebackItemBuyReport",
          component: RebackItemBuyReport
        },
        {
          path: "/RebackImporterReport",
          name: "RebackImporterReport",
          component: RebackImporterReport
        },
        {
          path: "/MasrofAllReport",
          name: "MasrofAllReport",
          component: MasrofAllReport
        },
        {
          path: "/MasrofWithTypeReport",
          name: "MasrofWithTypeReport",
          component: MasrofWithTypeReport
        },
        {
          path: "/RebackSellAll",
          name: "RebackSellAll",
          component: RebackSellAll
        },
        {
          path: "/RebackSellAllByFatwora",
          name: "RebackSellAllByFatwora",
          component: RebackSellAllByFatwora
        },
        {
          path: "/RebackBuyAll",
          name: "RebackBuyAll",
          component: RebackBuyAll
        },
        {
          path: "/UserBehaviorReport",
          name: "UserBehaviorReport",
          component: UserBehaviorReport
        },
        {
          path: "/StoreMovementReport",
          name: "StoreMovementReport",
          component: StoreMovementReport
        },
        {
          path: "/StoreMovementAllReport",
          name: "StoreMovementAllReport",
          component: StoreMovementAllReport
        },
        {
          path: "/ItemSalesAverageReport",
          name: "ItemSalesAverageReport",
          component: ItemSalesAverageReport
        },
        {
          path: "/ClientSalesValueReport",
          name: "ClientSalesValueReport",
          component: ClientSalesValueReport
        },
        {
          path: "/ClientSadadSalesAverageReport",
          name: "ClientSadadSalesAverageReport",
          component: ClientSadadSalesAverageReport
        },
        {
          path: "/ImporterAccount",
          name: "ImporterAccount",
          component: ImporterAccount
        },
        {
          path: "/FinalFatworas",
          name: "FinalFatworas",
          component: FinalFatworas
        },
        {
          path: "/FinalFatworasPrint/:id",
          name: "FinalFatworasPrint",
          component: FinalFatworasPrint
        },
        {
          path: "/OrderConfirmation",
          name: "OrderConfirmation",
          component: OrderConfirmation
        },
        {
          path: "/DashboardDetails",
          name: "DashboardDetails",
          component: DashboardDetails
        },
        {
          path: "/StoreOperationDetails",
          name: "StoreOperationDetails",
          component: StoreOperationDetails
        },
        {
          path: "/AccountDetails",
          name: "AccountDetails",
          component: AccountDetails
        },
        {
          path: "/BankDetails",
          name: "BankDetails",
          component: BankDetails
        },
        {
          path: "/BuyDetails",
          name: "BuyDetails",
          component: BuyDetails
        },
        {
          path: "/EmployerReportDetails",
          name: "EmployerReportDetails",
          component: EmployerReportDetails
        },
        {
          path: "/HrDetails",
          name: "HrDetails",
          component: HrDetails
        },
        {
          path: "/ImporterReportDetails",
          name: "ImporterReportDetails",
          component: ImporterReportDetails
        },
        {
          path: "/KhazinaDetails",
          name: "KhazinaDetails",
          component: KhazinaDetails
        },
        {
          path: "/KhazinaReportDetails",
          name: "KhazinaReportDetails",
          component: KhazinaReportDetails
        },
        {
          path: "/ManageReportDetails",
          name: "ManageReportDetails",
          component: ManageReportDetails
        },
        {
          path: "/RebackReportDetails",
          name: "RebackReportDetails",
          component: RebackReportDetails
        },
        {
          path: "/SalesDetails",
          name: "SalesDetails",
          component: SalesDetails
        },
        {
          path: "/SalesReportDetails",
          name: "SalesReportDetails",
          component: SalesReportDetails
        },
        {
          path: "/StorereportDetails",
          name: "StorereportDetails",
          component: StorereportDetails
        },
        {
          path: "/AddNewClient",
          name: "AddNewClient",
          component: AddNewClient
        },
        {
          path: "/mandobVisits",
          name: "mandobVisits",
          component: mandobVisits
        },
        {
          path: "/Tasks",
          name: "Tasks",
          component: Tasks
        },
        {
          path: "/Tahsilat",
          name: "Tahsilat",
          component: Tahsilat
        },
        {
          path: "/Track",
          name: "Track",
          component: Track
        },
        {
          path: "/Chat",
          name: "Chat",
          component: Chat
        },
        {
          path: "/MandobTargetInput",
          name: "MandobTargetInput",
          component: MandobTargetInput
        },
        {
          path: "/Profit",
          name: "Profit",
          component: Profit
        },
        {
          path: "/ProfiItem",
          name: "ProfiItem",
          component: ProfiItem
        },
        {
          path: "/TaxFatwora",
          name: "TaxFatwora",
          component: TaxFatwora
        },
        {
          path: "/FatworaBarcode",
          name: "FatworaBarcode",
          component: FatworaBarcode
        },
        {
          path: "/MandobSalesReportPrint",
          name: "MandobSalesReportPrint",
          component: MandobSalesReportPrint
        },
        {
          path: "/MandobItemReportPrint",
          name: "MandobItemReportPrint",
          component: MandobItemReportPrint
        },
        {
          path: "/MandobClientTypeReportPrint",
          name: "MandobClientTypeReportPrint",
          component: MandobClientTypeReportPrint
        },
        {
          path: "/MandobClientSadadReportPrint",
          name: "MandobClientSadadReportPrint",
          component: MandobClientSadadReportPrint
        },
        {
          path: "/MandobClientMadioniaReportPrint",
          name: "MandobClientMadioniaReportPrint",
          component: MandobClientMadioniaReportPrint
        },
        {
          path: "/ItemSalesReportPrint",
          name: "ItemSalesReportPrint",
          component: ItemSalesReportPrint
        },
        {
          path: "/ItemClientTypeReportPrint",
          name: "ItemClientTypeReportPrint",
          component: ItemClientTypeReportPrint
        },
        {
          path: "/ItemSalesAverageReportPrint",
          name: "ItemSalesAverageReportPrint",
          component: ItemSalesAverageReportPrint
        },
        {
          path: "/ClientSalesValueReportPrint",
          name: "ClientSalesValueReportPrint",
          component: ClientSalesValueReportPrint
        },
        {
          path: "/ClientSadadSalesAverageReportPrint",
          name: "ClientSadadSalesAverageReportPrint",
          component: ClientSadadSalesAverageReportPrint
        },
        {
          path: "/StoreItemTransferReportPrint",
          name: "StoreItemTransferReportPrint",
          component: StoreItemTransferReportPrint
        },
        {
          path: "/StoreOneItemTransferReportPrint",
          name: "StoreOneItemTransferReportPrint",
          component: StoreOneItemTransferReportPrint
        },
        {
          path: "/StoreMovementReportPrint",
          name: "StoreMovementReportPrint",
          component: StoreMovementReportPrint
        },
        {
          path: "/StoreMovementAllReportPrint",
          name: "StoreMovementAllReportPrint",
          component: StoreMovementAllReportPrint
        },
        {
          path: "/KhazinaClientSadadReportPrint",
          name: "KhazinaClientSadadReportPrint",
          component: KhazinaClientSadadReportPrint
        },
        {
          path: "/KhazinaInputDetailReportPrint",
          name: "KhazinaInputDetailReportPrint",
          component: KhazinaInputDetailReportPrint
        },
        {
          path: "/MasrofAllReportPrint",
          name: "MasrofAllReportPrint",
          component: MasrofAllReportPrint
        },
        {
          path: "/MasrofWithTypeReportPrint",
          name: "MasrofWithTypeReportPrint",
          component: MasrofWithTypeReportPrint
        },
        {
          path: "/BranchSalesReportPrint",
          name: "BranchSalesReportPrint",
          component: BranchSalesReportPrint
        },
        {
          path: "/BranchSalesReportAllDetailsPrint",
          name: "BranchSalesReportAllDetailsPrint",
          component: BranchSalesReportAllDetailsPrint
        },
        {
          path: "/CompanySalesReportPrint",
          name: "CompanySalesReportPrint",
          component: CompanySalesReportPrint
        },
        {
          path: "/BranchMadioniaReportPrint",
          name: "BranchMadioniaReportPrint",
          component: BranchMadioniaReportPrint
        },
        {
          path: "/CompanyMadioniaReportPrint",
          name: "CompanyMadioniaReportPrint",
          component: CompanyMadioniaReportPrint
        },
        {
          path: "/BarcodeSerial",
          name: "BarcodeSerial",
          component: BarcodeSerial
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/login2",
      name: "login2",
      component: Login2
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.userAuth)) {
    if (!localStorage.getItem("userAuth")) {
      router.push({
        path: "/login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.verifyAccount)) {
    // if (!localStorage.getItem("token")) {
    //   router.push({ path: "/CheckMail" });
    // } else {
    //   next();
    // }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
